// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"79":"fcf27c5a","613":"f0052026","748":"41a10ae9","764":"0a412b56"}[chunkId] + ".js";
};